import { Alert, Box, Button, type ButtonProps, Group } from "@mantine/core"
import { modals } from "@mantine/modals"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"

interface IProps extends ButtonProps {
  children?: ReactNode
  error?: ReactNode
  close?: () => void
  label?: string
  onSubmit?: () => void
}

export function ModalControls({ label, error, children, onSubmit, close = modals.closeAll, ...props }: IProps) {
  const { t } = useTranslation()
  return (
    <Group mt="xl">
      {error && <Alert color="red" w="100%" title={error} />}
      <Button variant="navy" onClick={close}>
        {t("Cancel")}
      </Button>
      <Box ml="auto">{children}</Box>
      <Button type="submit" variant="save" onClick={() => onSubmit?.()} {...props}>
        {label ?? t("Save")}
      </Button>
    </Group>
  )
}
